import { render } from "./Project-5.vue?vue&type=template&id=7d543417"
import script from "./Project-5.vue?vue&type=script&lang=js"
export * from "./Project-5.vue?vue&type=script&lang=js"
script.render = render

export default script